import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Container } from 'ui/container'
import { List } from 'features/advent/list'
import { Prize } from 'features/advent/prize'
import { useState, useEffect } from 'react'
import { userService } from 'core/services'
import { useAuthContext } from 'core/providers/AuthProvider'
import { toast } from 'react-toastify'

import c from './assets/sass/page.module.scss'
import { PageTitle } from '../../features/common/page-title'

const AdventPage = () => {
    const { t } = useTranslation()
    const [showPrize, setShowPrize] = useState(false)
    const [prizeData, setPrizeData] = useState(null)
    const [adventStatus, setAdventStatus] = useState(null)
    const [loading, setLoading] = useState(true)
    const { updateUserData } = useAuthContext()

    useEffect(() => {
        loadAdventStatus()
    }, [])

    const loadAdventStatus = async () => {
        try {
            setLoading(true)
            const status = await userService.getAdventStatus()
            setAdventStatus(status)
        } catch (error) {
            console.error('Ошибка загрузки адвент календаря:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleDayClick = async (day) => {
        try {
            console.log('🎁 Claiming reward for day:', day)
            const result = await userService.claimAdventReward(day)
            await updateUserData()

            setPrizeData(result)
            setShowPrize(true)
            toast(t('advent.error.prizeReceived'), { type: 'success' })

            await loadAdventStatus()
        } catch (error) {
            console.error('Ошибка получения приза:', error)
            const errorMsg = error.response?.data?.error

            if (errorMsg?.includes('не доступен')) {
                toast(t('advent.error.missed'), { type: 'error' })
            } else if (errorMsg?.includes('уже получен')) {
                toast(t('advent.error.alreadyClaimed'), { type: 'error' })
            } else {
                toast(errorMsg || t('advent.error.claimError'), {
                    type: 'error',
                })
            }
        }
    }

    const handlePrizeClose = () => {
        setShowPrize(false)
        setPrizeData(null)
    }

    const navigate = useNavigate()
    const handleFAQ = () => {
        navigate('/faq?category=modes')
    }

    if (loading) {
        return (
            <div className={c.component}>
                <PageTitle title={t('advent.title')} callback={handleFAQ} />
                <Container>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        {t('advent.list.loading')}
                    </div>
                </Container>
            </div>
        )
    }

    return (
        <div className={c.component}>
            <PageTitle title={t('advent.title')} callback={handleFAQ} />
            <Container>
                <List onDayClick={handleDayClick} adventStatus={adventStatus} />
            </Container>
            {showPrize && <Prize data={prizeData} onClose={handlePrizeClose} />}
        </div>
    )
}

export default AdventPage
